import type { ComponentProps } from 'react'
import Svg, { Path } from 'react-native-svg'
import { mesaColorNames } from '@/src/common/theme'
import * as Branding from '@/src/experiences/branding'

/** @see {@link https://www.figma.com/design/qaGLT95sJewnl3S2o7Xvus/iOS?node-id=3645-1540&m=dev} */
export function MesaLogo({
  variant = 'dualtone',
  ...props
}: ComponentProps<typeof Svg> & {
  variant?: // https://www.figma.com/design/qaGLT95sJewnl3S2o7Xvus/iOS?node-id=3645-1540&m=dev
  | 'dualtone'
    // https://www.figma.com/design/qaGLT95sJewnl3S2o7Xvus/iOS?node-id=3645-1565&m=dev
    | 'teal'
    // https://www.figma.com/design/qaGLT95sJewnl3S2o7Xvus/iOS?node-id=3645-1533&m=dev
    | 'gray'
    // https://www.figma.com/design/qaGLT95sJewnl3S2o7Xvus/iOS?node-id=3645-1549&m=dev
    | 'black'
    // https://www.figma.com/design/qaGLT95sJewnl3S2o7Xvus/iOS?node-id=3645-1556&m=dev
    | 'white'
    // https://www.figma.com/design/qaGLT95sJewnl3S2o7Xvus/iOS?node-id=3655-1601&m=dev
    | 'dualtone-black'
    // https://www.figma.com/design/qaGLT95sJewnl3S2o7Xvus/iOS?node-id=3655-1617&m=dev
    | 'dualtone-white'
}) {
  const { colorValue: primaryColor } = Branding.Hooks.usePrimaryColor()

  return (
    <Svg width={600} height={231} viewBox="0 0 600 231" fill="none" {...props}>
      <Path
        d="M266.3 98.81c0-4.24 3.37-7.73 7.73-7.73h1.62c3.37 0 5.61 1.75 7.1 4.11l26.43 41.38 26.55-41.51c1.62-2.62 3.86-3.99 6.98-3.99h1.62c4.36 0 7.73 3.49 7.73 7.73v73.87c0 4.24-3.37 7.6-7.73 7.6-4.11 0-7.6-3.49-7.6-7.6v-53.18l-21.32 32.03c-1.62 2.49-3.61 3.99-6.48 3.99-2.87 0-4.74-1.5-6.36-3.99l-21.19-31.79v53.06c0 4.24-3.36 7.48-7.6 7.48s-7.48-3.24-7.48-7.48v-74 .02zM402.91 180.33c-19.07 0-33.78-13.84-33.78-34.15v-.25c0-18.82 13.34-34.28 32.16-34.28 20.94 0 31.29 17.2 31.29 32.41 0 4.24-3.24 7.23-7.11 7.23h-41.26c1.62 10.72 9.22 16.7 18.95 16.7 6.36 0 11.34-2.24 15.58-5.73 1.12-.87 2.12-1.37 3.86-1.37 3.37 0 5.98 2.62 5.98 6.11 0 1.87-.87 3.49-1.99 4.61-5.98 5.36-13.46 8.73-23.68 8.73v-.01zm14.96-39.02c-1-9.72-6.73-17.33-16.7-17.33-9.22 0-15.71 7.1-17.08 17.33h33.78zM445.54 172.23c-1.62-.87-2.87-2.74-2.87-5.24 0-3.37 2.62-6.11 6.11-6.11 1.25 0 2.37.37 3.24.87 6.36 4.24 12.96 6.36 18.95 6.36 6.48 0 10.22-2.74 10.22-7.1v-.25c0-5.11-6.98-6.86-14.71-9.22-9.72-2.74-20.57-6.73-20.57-19.32v-.25c0-12.46 10.35-20.07 23.43-20.07 6.98 0 14.33 1.99 20.69 5.36 2.12 1.12 3.61 3.12 3.61 5.73 0 3.49-2.74 6.11-6.23 6.11-1.25 0-1.99-.25-2.99-.75-5.36-2.74-10.84-4.49-15.46-4.49-5.86 0-9.22 2.74-9.22 6.48v.25c0 4.86 7.1 6.86 14.83 9.35 9.6 2.99 20.44 7.35 20.44 19.2v.25c0 13.84-10.72 20.69-24.43 20.69-8.35 0-17.45-2.62-25.05-7.85h.01zM506.11 159.89v-.25c0-14.21 11.09-21.19 27.17-21.19 7.35 0 12.59 1.12 17.7 2.74v-1.62c0-9.35-5.73-14.34-16.33-14.34-5.73 0-10.47 1-14.58 2.62-.87.25-1.62.37-2.37.37-3.49 0-6.36-2.74-6.36-6.23 0-2.74 1.87-5.11 4.11-5.98 6.23-2.37 12.59-3.86 21.19-3.86 9.85 0 17.2 2.62 21.81 7.35 4.86 4.74 7.1 11.72 7.1 20.32v32.41c0 4.11-3.24 7.23-7.35 7.23-4.36 0-7.35-2.99-7.35-6.36v-2.49c-4.49 5.36-11.34 9.6-21.44 9.6-12.34 0-23.31-7.1-23.31-20.32h.01zm45.12-4.74v-4.49c-3.86-1.5-8.97-2.62-14.96-2.62-9.72 0-15.46 4.11-15.46 10.97v.25c0 6.36 5.61 9.97 12.84 9.97 9.97 0 17.58-5.73 17.58-14.09v.01z"
        fill={(() => {
          switch (variant) {
            case 'dualtone':
            case 'gray':
              return mesaColorNames['Mesa - Brand/Secondary #223843']
            case 'teal':
              return mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9']
            case 'black':
            case 'dualtone-black':
              return mesaColorNames['Mesa - Brand/Blackish #222222']
            case 'white':
            case 'dualtone-white':
              return mesaColorNames['Mesa - Brand/White #FFFFFF']
            default:
              // if this check fails, we haven't handled every possible variant
              variant satisfies never
              return mesaColorNames['Mesa - Brand/Secondary #223843']
          }
        })()}
      />
      <Path
        d="M219.448 195.83h-42.412c-6.613 0-11.992-5.379-11.992-11.991V144.98l-28.236 16.838a8.006 8.006 0 01-8.185 0l-28.236-16.838v38.859c0 6.612-5.379 11.991-11.992 11.991H45.992C39.38 195.83 34 190.451 34 183.839v-95.71c0-4.553 2.645-8.786 6.746-10.784l86.732-42.133a11.945 11.945 0 0110.484 0l86.723 42.133c4.101 1.998 6.755 6.222 6.755 10.785v95.709c0 6.612-5.379 11.991-11.992 11.991zm-21.233-15.986h17.238V90.633l-82.737-40.2-82.73 40.2v89.211h34.415v-48.932a7.992 7.992 0 0112.09-6.861l36.225 21.604 36.225-21.604a8.014 8.014 0 018.042-.089 7.989 7.989 0 014.047 6.95v48.932h17.185z"
        fill={(() => {
          switch (variant) {
            case 'dualtone':
            case 'teal':
            case 'dualtone-black':
            case 'dualtone-white':
              return primaryColor
            case 'gray':
              return mesaColorNames['Mesa - Brand/Secondary #223843']
            case 'black':
              return mesaColorNames['Mesa - Brand/Blackish #222222']
            case 'white':
              return mesaColorNames['Mesa - Brand/White #FFFFFF']
            default:
              // if this check fails, we haven't handled every possible variant
              variant satisfies never
              return mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9']
          }
        })()}
      />
    </Svg>
  )
}
